const isDisplayedGranteeSitPro = ({ getMiddleBoolean, granteeIsChild }) =>
  getMiddleBoolean('BENEFICIAIRE_SIT_PRO_EST_NECESSAIRE') &&
  (getMiddleBoolean('BENEFICIAIRE_SIT_PRO_EST_DEMANDE_DONNEES_CONTRAT') ||
    getMiddleBoolean('BENEFICIAIRE_SIT_PRO_EST_DEMANDE_DONNEES_SOUSCRIPTION')) &&
  !granteeIsChild;

export { isDisplayedGranteeSitPro };
